import { version, isPermission } from '../../config';
const navs = [
	{
		name: '首页',
		key: 'home',
		permissionName:'HomePageManage',
		menus: [
			{
				path: 'home',
				icon: 'i-home',
				name: '首页',
				to: `/home/home/${version}`,
				permit: false,
                permissionName:'HomePage',
			}, {
				path: 'info',
				icon: 'i-coupon-list',
				name: '商户信息',
				to: `/home/info/${version}`,
				permit: false,
                permissionName:'MchManage',
			}, 
			{
				path: 'StorMan',
				icon: 'i-coupon-list',
				name: '门店管理',
				to: `/home/StorMan/${version}`,
				permit: false,
                permissionName:'StoreMange',
			},
			{
				path: 'PerMan',
				icon: 'i-user',
				name: '用户管理',
				to: `/home/PerMan/${version}`,
				permit: false,
                permissionName:'PersonnelManage',
			},
			{
				path: 'groMan',
				icon: 'i-group',
				name: '组管理',
				to: `/home/groMan/${version}`,
				permit: false,
                permissionName:'GroupManage',
			},
			{
				path: 'services',
				icon: 'i-coupon-list',
				name: '服务类别管理',
				to: `/home/services/${version}`,
				permit: false,
                permissionName:'MchServiceManage',
			},
		]
	},
	{
		name: '会员管理',
		key: 'member',
		permissionName:'MemberManage',
		menus: [
			{
				path: 'MemMan',
				icon: 'i-coupon-list',
				name: '会员列表',
				to: `/member/MemMan/${version}`,
				permit: false,
                permissionName:'UserList',
			},
			{
				path:'level',
				icon: 'i-coupon-list',
				name: '会员等级列表',
				to :`/member/level/${version}`,
				permit: false,
                permissionName:'UserLevel',
			},
		]
	},
	{
		name: '营销管理',
		key: 'sale',
		permissionName:'MarketingManage',
		menus: [
			{
				path: 'Coupon',
				icon: 'i-coupon-list',
				name: '优惠券管理',
				to: `/sale/Coupon/${version}`,
				permit: false,
                permissionName:'CouponManage',
			},
			{
				path: 'unauditCoupon',
				icon: 'i-coupon-list',
				name: '待审核优惠券列表',
				to: `/sale/unauditCoupon/${version}`,
				permit: true,
                permissionName:'ApplyCouponList',
			},
			{
				path: 'ConsulMan',
				icon: 'i-information',
				name: '资讯管理',
				to: `/sale/ConsulMan/${version}`,
				permit: false,
                permissionName:'FindNewsList',
			},

		]
	},
	{
		name: '财务管理',
		key: 'order',
		permissionName:'OrderMange',
		// permissionName:'OrderMange',
		menus: [
			{
				path: 'orderlist',
				icon: 'i-order',
				name: '订单列表',
				to: `/order/orderlist/${version}`,
				permit: false,
                // permissionName:'',
                permissionName:'OrderList',
			}, 
			// {
			// 	path: 'orderfefundlist',
			// 	icon: 'i-order',
			// 	name: '退款订单列表',
			// 	to: `/order/orderfefundlist/${version}`,
			// 	permit: true,
            //     permissionName:'',
			// },
			{
				path: 'settle',
				icon: 'i-order',
				name: '收银台',
				to: `/order/settle/${version}`,
				permit: false,
                permissionName:'SettleManage',
			}
		]
	},
	{
		name: '应用管理',
		key: 'app',
		permissionName:'AppManage',
		menus: [
			{
				path: 'applist',
				icon: 'i-coupon-list',
				name: '应用管理',
				to: `/app/applist/${version}`,
				permit: false,
                permissionName:'ApplicationManage',
			},
			{
				path: 'keylist',
				icon: 'i-information',
				name: '支付管理',
				to: `/app/keylist/${version}`,
				permit: false,
                permissionName:'PaymentManage',
			}
		]
	},
	// {
	//   name:'服务跟进管理',
	//   key:'service',
	//   menus:[
	//     {
	//       path: 'follow',
	//       icon: 'i-coupon-list',
	//       name: '服务跟进列表',
	//       to:`/service/follow/${version}`,
	//       permit: true,
	//     },
	//     {
	//       path: 'order',
	//       icon: 'i-coupon-list',
	//       name: '预约列表',
	//       to:`/service/order/${version}`,
	//       permit: true,
	//     }
	//   ]
	// },
	{
		name: '商品管理',
		key: 'product',
		permissionName:'ProductManage',
		menus: [
			{
				path: 'spu',
				icon: 'i-course-list',
				name: '商品列表',
				to: `/product/spu/${version}`,
				permit: false,
                permissionName:'ProductListManage',
			},
			{
				path: 'productclass',
				icon: 'i-course-list',
				name: '商品分类管理',
				to: `/product/productclass/${version}`,
				permit: false,
                permissionName:'CategoryManage',
			},
			{
				path: 'attributegroup',
				icon: 'i-course-list',
				name: '属性组列表',
				to: `/product/attributegroup/${version}`,
				permit: false,
                permissionName:'AttrGroupListManage',
			},
			{
				path: 'attributelist',
				icon: 'i-course-list',
				name: '属性列表',
				to: `/product/attributelist/${version}`,
				permit: false,
                permissionName:'AttrListManage',
			},
			{
				path: 'categorylist',
				icon: 'i-course-list',
				name: '类别列表',
				to: `/product/categorylist/${version}`,
				permit: false,
                permissionName:'CatalogListManage',
			},
			{
				path: 'option',
				icon: 'i-course-list',
				name: '选项列表',
				to: `/product/option/${version}`,
				permit: false,
                permissionName:'OptionListManage',
			}
		]
	},
	{
		name: '客服管理',
		key: 'feedback',
		permissionName:'ServiceManage',
		menus: [
			{
				path: 'feedbacklist',
				icon: 'i-coupon-list',
				name: '反馈列表',
				to: `/feedback/feedbacklist/${version}`,
				permit: false,
                permissionName:'FeedbackListManage',
			}, 
			// {
			// 	path: 'deal',
			// 	icon: 'i-coupon-list',
			// 	name: '反馈处理列表',
			// 	to: `/feedback/deal/${version}`,
			// 	permit: false,
            //     permissionName:'FeedbackDealList',
			// },
			{
				path: 'applylist',
				icon: 'i-coupon-list',
				name: '优惠申请列表',
				to: `/feedback/applylist/${version}`,
				permit: false,
				permissionName:'ApplayList',
			},
			{
				path: 'addapply',
				icon: 'i-coupon-list',
				name: '优惠申请',
				to: `/feedback/addapply/${version}`,
				permit: false,
				permissionName:'',
			}
		]
	},
]

export default navs;



// WEBPACK FOOTER //
// ./src/components/Page/navs.config.js